import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BookCheck, ChevronLeft, ChevronRight, ListChecks, NotebookPen, User, Users } from "lucide-react";

import ButtonV2 from "../../components/ui/button/v2";
import Stepper, { StepItem } from "../../components/ui/stepper";

import CreateCaseForm from "./components/CreateCaseForm";

const steps: StepItem[] = [
    { id: 1, label: "Select Type", icon: <ListChecks width="16" height="16" /> },
    { id: 2, label: "Basic Details", icon: <Users width="16" height="16" /> },
    { id: 3, label: "Background", icon: <NotebookPen width="16" height="16" /> },
    { id: 4, label: "Party Involved", icon: <User width="16" height="16" /> },
    { id: 5, label: "Review & Submit", icon: <BookCheck width="16" height="16" /> },
];

const CreateCasePage: React.FC = () => {
    const navigate = useNavigate();
    const [currentActiveStep, setCurrentActiveStep] = useState(0);

    const onStepChange = useCallback((stepIndex: number) => {
        setCurrentActiveStep(stepIndex);
    }, []);

    return (
        <div className="flex-1 overflow-auto">
            <div className="relative flex items-center p-4 md:p-6 lg:p-8">
                <ButtonV2
                    variant="link"
                    className="p-0 inline-flex items-center gap-2 text-sm text-gray-600 hover:text-blue-700 transition-colors duration-200 group underline-offset-0 hover:no-underline"
                    textClassName="font-semibold"
                    onClick={() => navigate('/cases')}
                    prefix={<ChevronLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform duration-200" />}
                >
                    Back to Cases
                </ButtonV2>

                <Stepper
                    steps={steps}
                    activeIndex={currentActiveStep}
                    split={<ChevronRight width={16} height={16} color="#737373"/>}
                    size="sm"
                    containerClassName="w-auto absolute left-1/2 transform -translate-x-1/2"
                    className="py-0"
                />
            </div>
            <CreateCaseForm
                stepCount={steps.length}
                currentStep={currentActiveStep}
                onStepChange={onStepChange}
            />
        </div>
    );
}

export default CreateCasePage;